import { Controller, Shark, Utils } from "shark-mvc";
import { NousCore } from "nouscore-js-api";

class NotComplianceReportManager extends Controller {
	constructor() {
		super("notComplianceReportManager");

		this.remoteClassName = "not-compliance-report";
	}
	
	getLatest () {
		const rd = NousCore.api.createRequest();
		const requestedAction = "get-latest";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						const latestNotComplianceReportList = Shark.getInstanceList("NotComplianceReport", data.items);

						Shark.set({
							latestNotComplianceReportList
						});

						return {
							data: latestNotComplianceReportList,
							requestedAction,
							status: "ok"
						};
					case 404:
						return {
							data,
							requestedAction,
							status: "ko"
						};
				}
			}
		});
	}

	getList () {
		const rd = NousCore.api.createRequest();
		const requestedAction = "get-list";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						const notComplianceReportList = Shark.getInstanceList("NotComplianceReport", data.items);

						notComplianceReportList.sort((a, b) => {
							if (a.updatedAt > b.updatedAt) {
								return -1;
							}
							else if (a.updatedAt < b.updatedAt) {
								return 1;
							}
						});

						Shark.set({
							notComplianceReportList,
						});

						return {
							data: notComplianceReportList,
							requestedAction,
							status: "ok"
						};
					case 404:
						return {
							data,
							error: data.error,
							requestedAction,
							status: "ko"
						};
				}
			}
		});
	}

	getListByConstructionSite (currConstructionSite) {
		const rd = NousCore.api.createRequest({ item: currConstructionSite.export() });
		const action = "get-list-by-construction-site";

		return NousCore.api.send(`${this.remoteClassName}/${action}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						const notComplianceReportList = Shark.getInstanceList("NotComplianceReport", data.items);

						notComplianceReportList.sort((a, b) => {
							if (a.updatedAt > b.updatedAt) {
								return -1;
							}
							else if (a.updatedAt < b.updatedAt) {
								return 1;
							}
						});

						Shark.set({
							notComplianceReportList,
						});

						notComplianceReportManager.emit("listChanged");
						return {
							data: notComplianceReportList,
							requestedAction: action,
							status: "ok"
						};
					case 404:
						notComplianceReportManager.emit("listGetError");
						return {
							data,
							error: data.error,
							requestedAction: action,
							status: "ko"
						};
				}
			}
		});
	}

	save (notComplianceReport) {
		const rd = NousCore.api.createRequest({ item: notComplianceReport.export() });
		const action = notComplianceReport.guid === "" ? "insert" : "update";

		return NousCore.api.send(`${this.remoteClassName}/${action}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						notComplianceReport.import(data.items[0]);
						notComplianceReport.clean();
		
						// notComplianceReportManager.emit("saved");
						return {
							data: notComplianceReport,
							requestedAction: action,
							status: "ok"
						};	
						break;
					case 99:
						// notComplianceReportManager.emit("saveError");
						return {
							data: "",
							requestedAction: action,
							status: "ko"
						};
				}
			}
		});
	}

	uploadAttachment (target, attachmentField) {
		const action = "upload-attachment";

		return NousCore.api.uploadFiles(target, `${this.remoteClassName}/${action}`).then(function (jsonData) {
			const currNotComplianceReport = Shark.get("currNotComplianceReport");
			const savedFiles = jsonData.payload.items;

			savedFiles.forEach(savedFile => {
				switch (savedFile.rc) {
					case 1:
						const fileType = savedFile.filePath.substr(savedFile.filePath.lastIndexOf(".") + 1).toLowerCase();
						currNotComplianceReport[attachmentField].attachments.push({
							guid: Shark.__generateGUID(),
							fileSize: savedFile.size,
							label: savedFile.name,
							source: "constructionSite",
							// thumbURL: "/images/icons/" + savedFile.filePath.substr(savedFile.filePath.lastIndexOf(".") + 1) + ".png",
							// type: savedFile.filePath.substr(savedFile.filePath.lastIndexOf(".") + 1),
							// url: Shark.get("__cdnURL") + savedFile.filePath
							thumbURL: savedFile.thumbnailFilPath ? "/" + savedFile.thumbnailFilPath : ["jpg", "jpeg", "png"].indexOf(fileType) > -1 ? "/" + savedFile.filePath : "/images/icons/" + fileType + ".png",
							type: fileType,
							url: "/" + savedFile.filePath,
						});
						// notComplianceReportManager.emit("fileUploaded", savedFile.filePath);
						break;
					case 95:
						// let data = {
						// 	tempFile: savedFile.errors[0].erroData.tempFile,
						// 	originalName: savedFile.errors[0].erroData.originalName,
						// 	type: "pictureURL"
						// };
						// notComplianceReportManager.emit("fileAlreadyPresentError", data);
						break;
					default:
						alert("Attezione, si è verificato il seguente errore:\n\n" + savedFile.errors[0].errorDescription);
				}
			});

			// Shark.render();
			return {
				data: currNotComplianceReport,
				status: "ok"
			}
		});
	}
}

const notComplianceReportManager = new NotComplianceReportManager();

Shark.registerController(notComplianceReportManager);

export { notComplianceReportManager };
